module.exports = __webpack_public_path__ + "static/media/git.c31b5069.svg";